<template>
  <div>
    <div class="marginCenter">
      <div class="marginBom18 marginTop30 categoryTitle2 flex-yCenter flex-sb">
        <div class="left flex">
          <span>缺勤情况登记</span>
        </div>
        <div class="right flex-yCenter">
          <img src="@/assets/images/index/fanhui.png" alt="" />
          <router-link
            tag="span"
            to="/process/index"
            class="backIndex fcolor_blue2 fsize16"
          >
            返回
          </router-link>
        </div>
      </div>
      <p class="tips">进修周期内可填写，超出进修周期只可查看</p>
      <div class="dept marginTop24 marginBom24">
        <span style="margin-right: 30px">进修科室：{{ query.trainObj.deptName }}</span>
        <span>进修周期：{{ query.trainObj.beginDate }}~{{ query.trainObj.endDate }}</span>
      </div>
      <div style="width: 500px">
        <el-form ref="form" :model="form" label-width="auto">
          <!-- 缺勤情况 -->
          <template v-if="query.registrationType == 1">
            <el-form-item label="出勤/天：">
              <el-input v-model="form.attendAttendance"></el-input>
            </el-form-item>
            <el-form-item label="迟到/天：">
              <el-input v-model="form.attendLate"></el-input>
            </el-form-item>
            <el-form-item label="早退/天：">
              <el-input v-model="form.attendLeaveEarly"></el-input>
            </el-form-item>
            <el-form-item label="请假/天：">
              <el-input v-model="form.leaveRequestsNumber"></el-input>
            </el-form-item>
          </template>
          <!-- 医疗问题 -->
          <template v-if="query.registrationType == 2">
            <el-form-item label="医疗纠纷（起）：">
              <el-input v-model="form.medicalDispute"></el-input>
            </el-form-item>
            <el-form-item label="医疗差错（起）：">
              <el-input v-model="form.medicalError"></el-input>
            </el-form-item>
            <el-form-item label="医疗事故（起）：">
              <el-input v-model="form.medicalMalpractice"></el-input>
            </el-form-item>
          </template>
          <template v-if="query.registrationType == 3">
            <el-form-item label="门/急诊平均每日诊治病人/人次：">
              <el-input v-model="form.diagnosisDailyAvg" style="width: 300px"></el-input>
            </el-form-item>
          </template>
          <template v-if="query.registrationType == 4">
            <el-form-item label="教学查房次数：">
              <el-input v-model="form.teachRounds"></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>

      <div class="btn">
        <el-button type="primary" v-if="query.operationType == 1" @click="submit"
          >确认提交</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { trainProcessDetail, trainProcessDetailModify } from "@/utils/api";
export default {
  components: {},
  data() {
    return {
      form: {},
      query: {
        trainObj: {},
      },
    };
  },
  methods: {
    submit() {
      trainProcessDetailModify(this.form).then((res) => {
        if (res.code == 200) {
          this.$message.success("登记成功");
        }
      });
    },
  },
  created() {
    let that = this;
    this.query = this.$route.query;
    this.query.trainObj = JSON.parse(this.query.trainObj);
    trainProcessDetail(this.query.trainObj.trainId).then((res) => {
      if (res.code == 200) {
        that.form = res.data;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.backIndex:hover {
  cursor: pointer;
}
.tips {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
}
.dept {
  span {
    font-size: 22px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #333333;
  }
}
::v-deep .el-form-item__label {
  text-align: left;
  font-size: 22px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #333333;
}
.btn {
  margin: 200px auto 0;
  text-align: center;
  button {
    width: 300px;
    height: 60px;
    background-color: #2d53c8;
    color: #fff;
    font-size: 22px;
    letter-spacing: 2px;
  }
}
</style>
